/* eslint-disable no-magic-numbers */
export const WhiteListIn = 0;
export const AskRequest = 1;
export const InReview = 2;
export const Accepted = 3;
export const Rejected = 4;
